import { Box } from "@components/Layout"
import { breakpoints } from "@config/theme"
import { rem } from "polished"
import styled from "styled-components"

export const BackgroundContainer = styled(Box)`
  position: absolute;
  height: 70%;
  width: 100vw;
  background-image: url("/static/img/configurator_background.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80vw auto;
  z-index: 0;
  @media screen and (min-width: ${breakpoints.medium}) {
    height: 100%;
  }
`

export const Grid = styled(Box)`
  height: 100%;
  overflow: hidden;
  width: 100%;
  display: grid;
  margin: 0 auto;
  grid-template-rows: 1fr 5fr 2fr 1fr;
  /* grid-row-gap: 0.5rem; */
  position: relative;
  z-index: 2;
  @media screen and (max-width: ${breakpoints.medium}) {
    grid-template-rows: 1fr 6fr 1fr 1fr;
  }
  @media screen and (max-width: ${breakpoints.small}) {
    grid-template-rows: 5fr 3.5fr 0.5fr 0.5fr;
  }
`
Grid.defaultProps = {
  pt: ["6rem", "6rem", "8rem"],
  pb: ["1rem", "1rem", "4rem"],
}

export const Row = styled(Box)`
  position: relative;
`

Row.defaultProps = {
  mx: "auto",
  maxWidth: rem(1600),
  width: ["100%", "95%"],
  px: ["5%", 0],
}
